function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const backdropStyles = process.env.NODE_ENV === "production" ? {
  name: "1jdi7b8",
  styles: "background-color:rgba(39, 49, 62, 0.75)"
} : {
  name: "tbfdop-backdropStyles",
  styles: "background-color:rgba(39, 49, 62, 0.75);label:backdropStyles;",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL2NpcmNsZWNpL3Byb2plY3QvYXNjZW5kL3NyYy9jb21wb25lbnRzL0JhY2tkcm9wL0JhY2tkcm9wLnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFFaUMiLCJmaWxlIjoiL2hvbWUvY2lyY2xlY2kvcHJvamVjdC9hc2NlbmQvc3JjL2NvbXBvbmVudHMvQmFja2Ryb3AvQmFja2Ryb3Auc3R5bGVzLnRzIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3NzIH0gZnJvbSAnQGVtb3Rpb24vcmVhY3QnO1xuXG5leHBvcnQgY29uc3QgYmFja2Ryb3BTdHlsZXMgPSBjc3NgXG4gIGJhY2tncm91bmQtY29sb3I6IHJnYmEoMzksIDQ5LCA2MiwgMC43NSk7XG5gO1xuIl19 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
};
export {
  backdropStyles
};
//# sourceMappingURL=Backdrop.styles.js.map
